import { t } from '@lingui/macro'
import { Button, Dialog, DialogContent, DialogTitle } from '@mui/material'
import React from 'react'

interface DeleteConfirmModalProps {
    open: boolean
    onClose: () => void
    onConfirm: () => void
    title: string
    message: string
    isLoading?: boolean
}

export const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({ open, onClose, onConfirm, title, message, isLoading = false }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth='sm'
            fullWidth
            PaperProps={{
                sx: {
                    width: '400px',
                    maxHeight: '90vh'
                }
            }}
        >
            <DialogTitle sx={{ pb: 1 }}>{title}</DialogTitle>
            <DialogContent sx={{ pt: 2 }}>
                <p className='text-sm text-gray-600 mb-6'>{message}</p>

                <div className='flex justify-end space-x-3'>
                    <Button
                        onClick={onClose}
                        disabled={isLoading}
                        variant='outlined'
                        className='border-gray-300 text-gray-700 hover:bg-gray-50'
                        aria-label={t`Cancel`}
                    >
                        {t`Cancel`}
                    </Button>
                    <Button
                        onClick={onConfirm}
                        disabled={isLoading}
                        variant='contained'
                        color='error'
                        className='bg-red-600 hover:bg-red-700'
                        aria-label={isLoading ? t`Deleting...` : t`Delete`}
                    >
                        {isLoading ? t`Deleting...` : t`Delete`}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    )
}
